import { ClientType } from "types/ClientType";
import { downloadFile, getCurrencyFromUuid } from "utils";
import { SharesByCompanyType } from "types/SharesTypes";
import { CompanyMyType, CompanyType } from "types/CompanyTypes";
import moment from "moment";
import { SVG_ENUM } from "enums";
import { SVG, ContextMenu } from "shared";

const items = ({
  item,
  setEditTransaction,
  company,
}: {
  item: SharesByCompanyType;
  setEditTransaction: (company: SharesByCompanyType) => void;
  company: CompanyType | null;
}) => {
  return (item: any) => {
    const actions = [];
    actions.push({
      name: "Edytuj",
      action: () =>
        setEditTransaction({
          ...item,
          name: company?.name || "",
          availableShares: company?.availableShares,
        }),
      svg: SVG_ENUM.EDIT,
    });

    actions.push({
      name: "Pobierz",
      action: () => downloadFile({ name: item.file.name, url: item.file.url }),
      svg: SVG_ENUM.FILE,
    });

    return actions;
  };
};

export const mobileColumns = ({ company }: { company: CompanyType | null }) => [
  {
    width: "calc(100% - 20px)",
    render: (data: ClientType) => (
      <table className="side-modal__table">
        <tr>
          <td className="side-modal__table-label">Klient:</td>
          <td className="side-modal__table-cell">{data?.name || "-"}</td>
        </tr>
        <tr>
          <td className="side-modal__table-label">Data:</td>
          <td className="side-modal__table-cell">
            {moment(data.createdAt).format("DD/MM/YYYY")}
          </td>
        </tr>
        <tr>
          <td className="side-modal__table-label">Zakupione udziały:</td>
          <td className="side-modal__table-cell">{data.sharesCount || "-"}</td>
        </tr>
        <tr>
          <td className="side-modal__table-label">Wartość udziałów:</td>
          <td className="side-modal__table-cell">
            {data?.sharesValue || "-"}{" "}
            {data?.pricePerShare && company
              ? getCurrencyFromUuid(company?.currencyUuid)
              : null}
          </td>
        </tr>

        <tr>
          <td className="side-modal__table-label">Wartość jednego udziału:</td>
          <td className="side-modal__table-cell">
            {data?.pricePerShare || "-"}{" "}
            {data?.pricePerShare && company
              ? getCurrencyFromUuid(company?.currencyUuid)
              : null}
          </td>
        </tr>
      </table>
    ),
  },
];

export const desktopColumns = ({
  company,
  setEditTransaction,
}: {
  company: CompanyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
}) => {
  return [
    {
      title: "Klient",
      dataIndex: "name",
      key: "name",
      width: 150,
    },
    {
      title: "Data",
      width: 150,
      dataIndex: "completedAt",
      key: "completedAt",
      render: (item: string) => moment(item).format("DD/MM/YYYY"),
    },
    {
      title: "Ilość sztuk",
      width: 100,
      render: (item: SharesByCompanyType) => (
        <span className={`transactions-table__number`}>
          {/* {item?.type === "buy" ? "+" : "-"} */}
          {item?.sharesCount}
        </span>
      ),
    },
    {
      title: "Koszt nabycia",
      width: 150,
      render: (item: SharesByCompanyType) =>
        item?.sharesValue ? (
          <span className={`transactions-table__number `}>
            {item?.sharesValue}{" "}
            {company?.currencyUuid &&
              getCurrencyFromUuid(company?.currencyUuid)}
          </span>
        ) : (
          "-"
        ),
    },
    {
      title: "Cena nabycia",
      width: 150,
      render: (item: SharesByCompanyType) =>
        item?.sharesValue ? (
          <span className={`transactions-table__number `}>
            {item?.pricePerShare}{" "}
            {company?.currencyUuid &&
              getCurrencyFromUuid(company?.currencyUuid)}
          </span>
        ) : (
          "-"
        ),
    },
    {
      width: 88,
      render: (item: SharesByCompanyType) => (
        <ContextMenu
          data={item}
          items={items({
            item,
            setEditTransaction,
            company,
          })(item)}
        >
          <SVG type={SVG_ENUM.DOTS} />
        </ContextMenu>
      ),
    },
  ];
};
export const summaryColumns = (item: CompanyType) => [
  {
    key: "type",
    width: 290,
    render: () => {
      return "Razem";
    },
  },
  {
    width: 100,
    render: (item: CompanyMyType) =>
      item?.sharesCount || (item.shares && item.shares[0]?.sharesCount),
  },
  {
    width: 300,
    render: (item: CompanyMyType) =>
      item?.sharesValue || (item.shares && item.shares[0]?.sharesValue) ? (
        <>
          {" "}
          {item?.sharesValue ||
            (item.shares && item.shares[0]?.sharesValue)}{" "}
          {getCurrencyFromUuid(item?.currencyUuid)}{" "}
        </>
      ) : (
        "-"
      ),
  },

  {
    width: 30,
  },
  {
    width: 40,
  },
];
